import { mode, PaymentMode } from '~/hooks/usePaymentMode';
import { useOwnerDistributionsPay } from './useOwnerDistributionsPay';
import { useOwnerDistributionsPortal } from './useOwnerDistributionsPortal';
import type { OwnerDistributionsStoreData } from '~/types/ownerDistributions';

export function useOwnerDistributionsByMode() {
  const portal = mode() === PaymentMode.Portal ? useOwnerDistributionsPortal() : null;
  const pay = mode() === PaymentMode.Pay ? useOwnerDistributionsPay() : null;

  const submitDistributions = (storeData: OwnerDistributionsStoreData) => {
    if (mode() === PaymentMode.Portal && portal) {
      return portal.submitDistributions(storeData);
    }
    if (mode() === PaymentMode.Pay && pay) {
      return pay.submitDistributions(storeData);
    }
    return Promise.reject(new Error('No owner distributions hook available for current payment mode'));
  };

  return { mode, submitDistributions };
}
